@if (isOnCall || isAdmin) {
  <div class="statuses" [style.justifyContent]="justifyContent">
    @if (isOnCall) {
      <div class="on-call" [style.color]="onCallColor">On Call</div>
    }
    @if (isAdmin) {
      <div class="admin">Admin</div>
    }
  </div>
}
